import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import  { FiscalPeriodManipulationView } from "./fiscalPeriodManipulation-view"

export class FiscalPeriodManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'سال مالی';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.fiscalPeriod = ObservableArray.create<fiscalPeriod>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new FiscalPeriodManipulationView();
    }
    public getTypeId(): string {
        return "VM-27B67E28-B77D-41B3-863D-B511CE220517"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set fiscalPeriod(v: ObservableArray<fiscalPeriod>) { this._fiscalPeriod = v; } public get fiscalPeriod(): ObservableArray<fiscalPeriod> { return this._fiscalPeriod;} private _fiscalPeriod: ObservableArray<fiscalPeriod>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllFiscalPeriod',{
                FilteringInformation:filteringInformation
            });
            let rowNumber = 1;
            this.fiscalPeriod.update(...result.FiscalPeriod.map(q=>{
                let r = new fiscalPeriod(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.from = moment.utc(q.From);
                r.until = moment.utc(q.Until);
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async requestFiscalPeriodCreation(){
        let editor = new fiscalPeriodEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }

}
export class fiscalPeriod extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:FiscalPeriodManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
        
    private _typedParent:FiscalPeriodManipulationViewModel;

}

interface IServerUpdater{
    execute(fiscalPeriod:fiscalPeriod):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'سال مالی با موفقیت ثبت شد.';
    }
    async execute(fiscalPeriod: fiscalPeriod): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/CreateFiscalPeriod',{
            From:fiscalPeriod.from.hour(0).minute(0).second(0).add(-210,'minutes'),
            Until:fiscalPeriod.until.hour(23).minute(59).second(59).add(-210,'minutes'),
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class fiscalPeriodEditor extends fiscalPeriod implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:FiscalPeriodManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(this.from==null || this.until == null){
            result.push(' تاریخ مشخص نشده است.')
        }
        return result;
    }
  
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت سال مالی');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }

}